import type { ReactNode } from "react";
import { Typography } from "@mui/material";
import type { TypographyProps } from "@mui/material";
import { grey } from "@mui/material/colors";
import Statut from "constants/Statut";

interface TypographyLineThroughIfRefusedProps extends TypographyProps {
  statut: Statut;
}

function TypographyLineThroughIfRefused({
  statut,
  children,
  ...props
}: Readonly<TypographyLineThroughIfRefusedProps>): ReactNode {
  return (
    <Typography
      {...props}
      sx={
        statut === Statut.REFUSE ? { textDecoration: "line-through", color: grey[500] } : undefined
      }>
      {children}
    </Typography>
  );
}

export default TypographyLineThroughIfRefused;
